export const PACKETA_METHOD_TYPE = 'packeta';
